import React from 'react'
import { connect } from 'react-redux'
import Search from '../components/Search'
import Header from '../components/Header'
import Categories from '../components/Categories'
import CallToActionBar from '../components/CallToActionBar'
import { fetchKnowledgeBases } from '../actions/knowledgeBaseActions'
import Loading from '../components/Loading'

const Home = ({ knowledgeBaseFaq, knowledgeBaseTree, loading, brand }) => {
	return (
		<>
			<Header />
			<Search brand={brand} />
			{<Loading isLoading={loading} brand={brand} />}
			{!loading && (
				<>
					<Categories brand={brand} items={knowledgeBaseTree} />
				</>
			)}
			<CallToActionBar brand={brand} />
		</>
	)
}

const mapStateToProps = state => ({
	knowledgeBaseFaq: state.knowledgeBase.knowledgeBaseFaq,
	knowledgeBaseTree: state.knowledgeBase.knowledgeBaseTree,
	loading: state.knowledgeBase.loading,
})
const mapDispatchToProps = dispatch => ({
	fetchKnowledgeBases: brand => dispatch(fetchKnowledgeBases(brand)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Home)
